import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "../../i18n";

export const TARGET = new Date("2026-12-11T00:00:00-05:00").getTime();

export const useCountdown = () => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const diff = Math.max(0, TARGET - now);
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    minutes: Math.floor(diff / 60000) % 60,
    seconds: Math.floor(diff / 1000) % 60,
  };
};

const Tile = ({ value, label, testid }) => (
  <div
    data-testid={testid}
    className="flex h-16 w-16 flex-col items-center justify-center bg-panettone shadow-[0_10px_24px_rgb(139,28,28,0.35)] sm:h-[4.5rem] sm:w-[4.5rem]"
  >
    <div className="relative h-7 overflow-hidden sm:h-8">
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.span
          key={value}
          initial={{ y: "70%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "-70%", opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="block font-serif text-2xl font-medium leading-none text-cream sm:text-3xl"
        >
          {String(value).padStart(2, "0")}
        </motion.span>
      </AnimatePresence>
    </div>
    <span className="mt-1.5 text-[8px] font-semibold uppercase tracking-[0.18em] text-cream/85 sm:text-[9px]">
      {label}
    </span>
  </div>
);

export const Countdown = () => {
  const { t } = useLang();
  const { days, hours, minutes, seconds } = useCountdown();

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, delay: 1.2, ease: [0.22, 1, 0.36, 1] }}
      data-testid="countdown"
      className="fixed bottom-4 left-1/2 z-50 -translate-x-1/2 sm:left-auto sm:right-6 sm:translate-x-0"
      role="timer"
      aria-label={t.countdown.prefix}
    >
      <div className="flex items-center gap-1.5 border border-gold/40 bg-ink/85 p-2 shadow-[0_18px_40px_rgb(26,22,20,0.4)] backdrop-blur-md sm:gap-2 sm:p-2.5">
        <Tile value={days} label={t.countdown.days} testid="countdown-days" />
        <Tile value={hours} label={t.countdown.hours} testid="countdown-hours" />
        <Tile value={minutes} label={t.countdown.minutes} testid="countdown-minutes" />
        <Tile value={seconds} label={t.countdown.seconds} testid="countdown-seconds" />
      </div>
    </motion.div>
  );
};
